import { render } from "./BasicInfo.vue?vue&type=template&id=774648ea&scoped=true&ts=true"
import script from "./BasicInfo.vue?vue&type=script&lang=ts"
export * from "./BasicInfo.vue?vue&type=script&lang=ts"

import "./BasicInfo.vue?vue&type=style&index=0&id=774648ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774648ea"]])

export default __exports__